import {Component, Input, OnInit} from '@angular/core';
import {PrlFinanceService} from '../../../services/prl-finance.service';
import {
  AffiliateBalanceMxObj,
  MxInformationTooltipConfig,
  MxInfoTooltipModule,
  MxPreloaderService,
  withPreloader
} from 'mx-core';
import {combineLatestAll, of, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {PrlLanguageModule} from '../../../../prl-language/prl-language.module';
import {BalanceItemComponent} from '../prl-balance-item/balance-item.component';
import {PaymentRequestPropertiesPrlObj} from '../../../../../../../generated/generated.model';

@Component({
  selector: 'prl-balance',
  imports: [
    PrlLanguageModule,
    BalanceItemComponent,
    MxInfoTooltipModule
  ],
  templateUrl: './prl-balance.component.html',
  styleUrl: './prl-balance.component.scss',
})
export class PrlBalanceComponent implements OnInit {
  @Input() balancePerMerchant: boolean = false;
  @Input() merchantBalance: AffiliateBalanceMxObj = null;
  @Input() merchantPRProperties: PaymentRequestPropertiesPrlObj = null;

  protected isPayableAffiliate: boolean = true;


  protected balanceConfig: MxInformationTooltipConfig = {
    links: [],
    header: 'Help',
    content: 'label.finance.account.balance.help'
  };

  private destroy$$: Subject<null> = new Subject<null>();
  private useSmartAmount: boolean = false;
  constructor(
      private financeService: PrlFinanceService,
      private preloader: MxPreloaderService
  ) {
  }

  ngOnInit(): void {
    this.useSmartAmount = this.financeService.getTotalPaymentRequestProperties().useSmartAmount;
    of(
        this.financeService.getDashboardBalance()
    ).pipe(takeUntil(this.destroy$$), withPreloader(this.preloader), combineLatestAll())
        .subscribe((response) => {
            this.financeService.setTotalBalance(response[0]);
        });
  }

  getLeftLabel = (): string => {
    if (!this.merchantBalance && !this.financeService.isNewPaymentRequest()) {
      return this.balancePerMerchant
          ? 'label.finance.account.balance.current.balance.total'
          : 'label.finance.account.balance.current.balance';
    } else {
      return 'label.finance.withdrawal.limit';
    }
  };

  getLeftValue = (): string => {
    if(!this.financeService.getTotalBalance()) {
      return '0';
    }

    if (!this.merchantBalance && !this.financeService.isNewPaymentRequest()) {
      return this.financeService.getTotalBalance().openingBalanceRounded.toString();
    } else {
      const balance = this.merchantBalance || this.financeService.getTotalBalance();
      return this.useSmartAmount
          ? balance.endingBalance.toString()
          : balance.openingBalance.toString();
    }
  };

  getCenterLabel = (): string => {
    if (!this.merchantBalance && !this.financeService.isNewPaymentRequest()) {
      return 'label.finance.account.balance.liabilities';
    } else {
      return 'label.finance.payment.request.threshold';
    }
  };

  getCenterValue = (): string => {
    if (!this.merchantBalance && !this.financeService.isNewPaymentRequest()) {
      return this.financeService.getTotalBalance() ? this.financeService.getTotalBalance().liabilities.toString() : '0';
    } else {
      return this.financeService.getTotalPaymentRequestProperties()
          ? this.financeService.getTotalPaymentRequestProperties().threshold.toString()
          : '0';
    }
  };

  getRightLabel = (): string => {
    if (!this.merchantBalance && !this.financeService.isNewPaymentRequest()) {
      return 'label.finance.account.balance.ending.balance';
    } else {
      return 'label.finance.payment.request.pending';
    }
  };

  getRightValue = (): string => {
    if (!this.financeService.getTotalBalance() || !this.financeService.getTotalPaymentRequestProperties()) {
      return '0';
    }

    if (!this.merchantBalance && !this.financeService.isNewPaymentRequest()) {
      return this.financeService.getTotalBalance().endingBalanceRounded.toString();
    } else {
      if (this.merchantPRProperties) {
        return this.merchantPRProperties.pendingAmount.toString();
      }
      return this.financeService.getTotalPaymentRequestProperties().pendingAmount.toString();
    }
  };
}
